import { render, staticRenderFns } from "./newProject.vue?vue&type=template&id=21a46a2b&scoped=true"
import script from "./newProject.vue?vue&type=script&lang=js"
export * from "./newProject.vue?vue&type=script&lang=js"
import style0 from "./newProject.vue?vue&type=style&index=0&id=21a46a2b&prod&scoped=true&lang=css"
import style1 from "./newProject.vue?vue&type=style&index=1&id=21a46a2b&prod&lang=css"
import style2 from "./newProject.vue?vue&type=style&index=2&id=21a46a2b&prod&scoped=true&lang=scss"
import style3 from "./newProject.vue?vue&type=style&index=3&id=21a46a2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a46a2b",
  null
  
)

export default component.exports